import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'simple-layout',
  template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/layouts/simple-layout.component.ts